import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import moment from "moment";
import dayjs from "dayjs";


const HandOver = ({ mode, handleCloseClick,editData }) => {
  const [parentId, setParentId] = useState([]);
  const [loading,setLoading]=useState(false)

//   useEffect(() => {
//    getData()
//   }, []);

//   const getData=async()=>{
//     setLoading(true)
//     const link = masterAPI["assetCategory"].link;
//    await axiosPrivate
//       .get(`${link}`)
//       .then((res) => {
//         setLoading(false)
//         setParentId(res.data.result);
//       })
//       .catch((e) => {
//         setLoading(false)
//         setParentId([])
//         console.log(e, "createACgetAll");
//       });
//   }

//   const initialValue = {
//     code: mode==="Edit"?editData.code: "",
//     assetCategoryName: mode==="Edit"?editData.assetCategoryName: "",
//     // parentCategoryId:mode==="Edit"?editData.parentCategoryId: null,
//   };

//   const onSubmit = async(value) => {
//     console.log(value);
//     setLoading(true)
//     const createLink = masterAPI["assetCategory"].create;
//     const updateLink=masterAPI["assetCategory"].update
//     if(mode==="Create"){
//      await axiosPrivate.post(`${createLink}`,value).then(res=>{
//         console.log(res.data)
//         setLoading(false)
//         handleCloseClick()
//       }).catch(e=>{
//         setLoading(false)
//         console.log(e,"createAC")
//       })
//     }else{
//       const updateAC={
//         id:editData.id,
//         ...value
//       }
//      await axiosPrivate.put(`${updateLink}`,updateAC).then(res=>{
//         console.log(res.data)
//         setLoading(false)
//         handleCloseClick()
//       }).catch(e=>{
//         setLoading(false)
//         console.log(e,"updateAC")
//       })
//     }
   
//   };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding}}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          Shift HandOver
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{border:"1px solid rgb(0 0 0 / 17%)",mb:"15px"}} />
      <Formik  >
      {({ handleChange, setFieldValue, values , resetForm }) => (
        <Form>
          <Grid container spacing={"1rem"}>
          <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift ID
                </Typography>
              <TextField
                size={"small"}
                value={"00005"}
                type="text"
                placeholder="Enter Shift ID"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift resp. area key
                </Typography>
              <TextField
                size={"small"}
                value={""}
                type="text"
                placeholder=""
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Responsible
                </Typography>
              <TextField
                size={"small"}
                value={"bfl - Bob Flynn"}
                type="text"
                placeholder=""
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Passoword
                </Typography>
              <TextField
                size={"small"}
                value={""}
                type="passoword"
                placeholder=""
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift type key
                </Typography>
              <TextField
                size={"small"}
                value={""}
                type="text"
                placeholder=""
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Start Date 
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY hh:mm"
                      value={dayjs("2020-01-31T07:36")}
                      readOnly
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                    //   onChange={(newValue) => {
                    //     console.log(newValue);
                    //     if (newValue !== null) {
                    //       if (`${newValue.$d}` !== "Invalid Date") {
                    //         const dateFrom = moment(newValue.$d).format(
                    //           "YYYY-MM-DD"
                    //         );
                    //         const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                    //         const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                    //         const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                    //         const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                    //         setFieldValue("installationDate", dateFormat);
                    //       }
                    //     }
                    //   }}
                    />
                  </DemoItem>
                </LocalizationProvider>
            </Grid>
            
            <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
              <Button
                onClick={handleCancel}
                variant="contained"
                sx={{
                  backgroundColor: color.TableCancelButton,
                  textTransform: "none",
                  color: color.CancelTextColor,
                  ":hover":{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                type={"submit"}
                variant="contained"
                disabled={loading}
                sx={{
                      
                  textTransform: "none",
                  backgroundColor: loading ? "default" : color.TableButtonColor,
                  "&:hover": {
                    backgroundColor: loading
                      ? "default"
                      : color.buttonDisable,
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
      </Formik>
    </Box>
  );
};

export default HandOver;
